<template>

  <div>

    <!-- Agent Info -->
     <agent-info></agent-info>


    <!-- Agent Cashflow -->
    <cashflow
        :source_id="agent_id"
        sourceFn="userCashflow"
        label="Agent"
        :name="agentProfile.name"
    ></cashflow>

    <!-- Commissions -->
    <agent-commissions
      :agentProfile="agentProfile"
    ></agent-commissions>

    <!-- Permissions -->
    <agent-permissions></agent-permissions>

    <!-- Notes -->
    <agent-notes
      :agent_id="$route.params.agent_id"
    ></agent-notes>

    <!-- Files -->
    <agent-files
      :agent_id="$route.params.agent_id"
    ></agent-files>


  </div>
</template>
<script type="text/babel">
  import Modal from '../assets/Modal.vue';
  import draggable from 'vuedraggable';
  import Dropdown from '../assets/Dropdown.vue';
  import DropdownConfirmation from '../assets/DropdownConfirmation.vue';
  import Autocomplete from '../assets/Autocomplete.vue';
  import AgentInfo from './AgentInfo.vue';
  import AgentPermissions from './AgentPermissions.vue';
  import AgentCommissions from './AgentCommissions.vue';
  import AgentFiles from './AgentFiles.vue';
  import AgentNotes from './AgentNotes.vue';
  import Cashflow from '../assets/Cashflow.vue';
  export default {
    name: 'AgentEdit',
    data: function(){
      return {
        agent_id: '',
        selectedOverrideAgent:{},
        selectedCarrier: {},
        showAddOverride: false,
        active: 'default',
        editing: '',
        agentProfile:{
          user_id: null,
          username: null,
          name: null,
          Abcomm: null,
          telno:null,
          sandler_username:null,
          sandler_password:null,
          sandler_id:null,
          email: null,
          is_channel: false
        },
        agents:[],
        carriers:[],
        channels:[],
        channel: '',
        agentCommissions:{
          default:{},
          carriers:[]
        },
        statuses:[
          'Active',
          'Inactive'
        ],
        selected:{},
        selectedComms:{
          carrier_id: null,
          carrier_name: null,
          sandler_commsrate: null,
          sandler_spiffrate: null,
          tier1_commsrate: null,
          tier1_spiffrate: null,
          tier2_commsrate: null,
          tier2_spiffrate: null,
          tier3_commsrate: null,
          tier3_spiffrate: null,
          tier4_commsrate: null,
          tier4_spiffrate: null,
          overrides:[]
        },
        draggableOptions:{
          handle: ".drag-handle",
          animation: 150
        }

      }
    },
    components:{
      Dropdown,
      DropdownConfirmation,
      Autocomplete,
      draggable,
      Modal,
      AgentInfo,
      AgentPermissions,
      AgentCommissions,
      AgentFiles,
      AgentNotes,
      Cashflow
    },
    computed:{
      agentNames(){
        return this.agents.map(function(u){
          return u.name;
        })
      },
      carrierNames(){
        return this.carriers.map(function(c){
          return c.name;
        })
      },
      newOverrideCarrierName(){
        return this.selectedCarrier.name;
      },
      selectedOverrideAgentName(){
        return this.selectedOverrideAgent.name;
      }

    },
    created(){
      this.agent_id = this.$route.params.agent_id;

      this.fetchProfile();
      this.fetchAgents();
      this.fetchChannels();
      this.fetchAgentCommissions();
      this.fetchCarriers();
    },
    filters:{
      displayStatus(status){
        return (status == "1")? 'Active' : 'Inactive';
      }

    },
    methods:{
      saveNewAgentOverride(){
        var _this = this;

        if(this.selectedOverrideAgent.user_id){

          this.$send(this, 'newUserOverride',{
            user_id: this.$route.params.agent_id,
            carrier_id: this.selectedCarrier.carrier_id,
            user: this.selectedOverrideAgent
          }).then(r => {
            this.fetchAgentCommissions();
            this.showAddOverride = false;
            this.selectedOverrideAgent = {};
          });
        } else {
          alert('No carrier selected');
        }
      },
      saveNewCarrierOverride(){


        if(this.selectedCarrier.carrier_id){


          this.$send(this, 'newCarrierOverride',{
            user_id: this.$route.params.agent_id,
            carrier: this.selectedCarrier
          }).then(r => {
            this.fetchAgentCommissions();
            this.showAddOverride = false;
          });

        } else {
          alert('No carrier selected');
        }

      },
      saveNewOrder(){

        this.$send(this, 'reorderOverride',{
          user_id: this.$route.params.agent_id,
          carrier_id: this.selectedComms.carrier_id || null,
          overrides: this.selectedComms.overrides
        }).then(r => {
          this.fetchProfile();
          this.editing = null;
        });




      },
      deleteOverride(parent){

        this.$send(this, 'deleteOverride',{
          user_id: this.$route.params.agent_id
        }).then(r => {
          this.fetchProfile();
          this.editing = null;
        });



      },
      setNewOverrideAgent(agent){
        this.selectedOverrideAgent = this.agents.filter(function(u){
          return u.name == agent;
        })[0];
      },
      setNewCarrier(carrier){

        this.selectedCarrier = this.carriers.filter(function(c){
          return c.name == carrier;
        })[0];

      },
      setStatus(status){

        this.selected.status = (status == 'Active') ? 1: 0;
      },
      saveInfo(){

        var data = this.selected;
        data.user_id = this.$route.params.agent_id;


        this.$send(this, 'userProfileUpdate',data).then(r => {
          this.fetchProfile();
          this.editing = null;
        });

      },
      setChannel(selection){
        this.channel = selection;
      },

      editInfo(){
          this.editing = 'info';
          this.selected = JSON.parse(JSON.stringify(this.agentProfile));
      },
      fetchProfile(){


        this.$send(this, 'userProfile',{
          user_id: this.$route.params.agent_id
        }).then(r => {
          this.agentProfile = r.userProfile;
        });

      },
      fetchAgentCommissions(){


        this.$send(this, 'userCommissions',{
          user_id: this.$route.params.agent_id
        }).then(r => {
          this.agentCommissions = r.userCommissions;
          this.selectedComms =  this.agentCommissions.default;
        });
      },
      fetchChannels(search){

        this.$send(this, 'channels', {
          search: search
        }).then(r => {
          // this.channels = r.channels;
        });
      },
      fetchAgents(){
        this.$send(this, 'userUsers' ).then(r => {
          this.agents = r.userUsers;
        });
      },
      fetchCarriers(){
        this.$send(this, 'carriers' ).then(r => {
          this.carriers = r.carriers;
        });
      },
      setActive(carrier){

        this.selectedComms = carrier;
        this.active = (this.active != carrier.carrier_name) ? carrier.carrier_name : null;


      },
      isActive(label){
        return this.active == label;
      }
    },
    mounted(){

    },
    props:[]
  }
</script>

<style>
  .row{
    position: relative;
  }
  .commission-section {
    padding: 10px 15px;
    border: 1px solid #e2e2e2;
  }
  .commission-section.active {
    background: #f0f7fc;
    border: 1px solid #aabcca;
  }

  .commission-section .section-header{
    cursor: pointer;
  }


  .commission-section .section-header i{
    -webkit-transition: .25s ease-in-out;
    -moz-transition: .25s ease-in-out;
    -o-transition: .25s ease-in-out;
  }
  .commission-section.active .section-header i{
    -ms-transform: rotate(90deg); /* IE 9 */
    -webkit-transform: rotate(90deg); /* Chrome, Safari, Opera */
    transform: rotate(90deg);
  }
  .commission-section.active .section-header{
  /*  border-bottom: 1px solid #aabcca; */
    margin-bottom: 20px;
  }
/*
  .commission-section.active .section-header {
    border: 1px solid white;
    margin-bottom: 20px;
    background: #325482;
    color: white;
  }
  */
  .commission-section .container{
    display: none;
    width: 100%;
  }
  .commission-section.active .container{
    display: block;
  }
  .row>.col.col-form-label,
  .row>[class^=col-].col-form-label{
    padding-top: 10px;
  }


  .drag-handle.col-form-label {
    width: 10px;
    color: #cccccc;
    padding: 15px 10px 15px 0;
    cursor: move;
    margin-right: 15px;
    position: absolute;
    left: -11px;
    top: 50%;
    height: 35px;
    margin-top: -18px;
  }
  .drag-handle i {
    margin: 0;
    padding: 0;
    font-size: 8px;
    line-height: 8px;
    margin-bottom: -15px;
    display: block;
  }
  .dragrow{
    background: white;
  }
  .sortable-ghost.sortable-chosen{
    background: #ccc;
    opacity:.25;
  }
  .sortable-drag{
    border: 1px solid #ccc;

    overflow: visible;
  }

  svg.svgIcon {
    width: 16px;
    height: 16px;
    color: #ccc;
  }

  .dropdown.confirmation {
    display: inline-block;
  }
  .dropdown.confirmation > .dropdown-menu {
    padding: 20px;
    font-size: 12px;
    width: 250px;
  }
  .confirmation-footer {
    margin-top: 30px;
    text-align: right;
  }


</style>



// WEBPACK FOOTER //
// AgentEdit.vue?586710ac